import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
// import { HuwonpopPage } from '../huwonpop/huwonpop';
// import { AccountPage } from '../account/account';

/**
 * Generated class for the HuwonPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-huwon',
	templateUrl: 'huwon.html',
})
export class HuwonPage {

    mode: string;
    loginId: string;
    api_key: string;
    version: string;
    wallet_address: string;
    chucheon_url: string;
	// items : any = [];
	total_sale: string;
	total_gold: string;
	unit: string;

	owners: any = [];
	list: any = [];
    items: any = [];
    // count_items: number = 0;
    max_items: number = 0;

    texts : any = [];
    language: string;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
		// private clipboard: Clipboard,
        public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public modalCtrl: ModalController,
		public app: App,
        private http: HttpService
    ) {

    }

    ionViewWillEnter() {
        //// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "huwon");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.unit = localStorage.getItem("unit");
        this.mode = localStorage.getItem("mode");

		this._get_texts();
		
		this._init('');
	}
	
	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).huwon;
	}

    // _copyAdd(item) {
	// 	this.clipboard.copy(this.wallet_address);
	// 	let alert = this.alertCtrl.create({
    //         title: "Copy",
    //         message: item,
	// 	    buttons: ['OK']
	// 	});
	// 	alert.present();
    // }
    
    // _invite() {
    //     this.navCtrl.push(InvitePage);
    // }

    // _add() {

	// 	let modal = this.modalCtrl.create(AccountPage, {chucheon: this.owners});
	// 	modal.present();
	// 	modal.onDidDismiss( data => {
	// 		this._init('');
	// 		// if (data == '' || data == null || data == undefined) {
	// 		// 	return;
	// 		// } else {
	// 		// 	this.ref({'up': '', 'idx': data});
	// 		// }
	// 	});
	// }

    _init(event) {
		// this.top_card = [];

		let url = "user/group/index/huwon";
		let body;
		if (event == '') {
			body = JSON.stringify({ 
				api: this.api_key,
				language: this.language,
				version: this.version
			});
		} else {
			if(event.up != '' && event.click == '') {
				if ( event.up.user_id == this.loginId) {
					// loader.dismiss();
					return;
				} else {
					body = JSON.stringify({
						api: this.api_key,
						language: this.language,
                        version: this.version,
						member: event.up.user,
						mode: "UP"
					});
				}
			} else if (event.up == '' && event.click != '') {
				body = JSON.stringify({ 
					api: this.api_key,
					language: this.language,
                    version: this.version,
					member: event.click,
					mode: ""
					
				});
			}
        }
        let loader = this.loadingCtrl.create({
			content: "loading..."
		});
        loader.present();
        
        this.owners = [];
        this.items = [];

		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.owners = res.owner[0];

                this._web(this.owners);
				if(res.list == undefined) {
					loader.dismiss();
					return;
				}else {					
					this.items = res.list;
					// this.list = res.list;
					// this.max_items = res.list.length;
					// this.items = [];
					// // this.count_items = 0;
					// for (var i = 1; i < this.max_items; i++) {
					// 	// if(this.max_items <= this.count_items) break;
					// 	this.items.push(this.list[i]);
					// 	// this.count_items ++;
					// }
					loader.dismiss();
				}
			} else if(res.result ==="LOGOUT"){
				loader.dismiss();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginEmail");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else if(res.result ==="DONOT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				this.navCtrl.pop();
			
			} else {
				loader.dismiss();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			loader.dismiss();
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

    _web(owners) {
        if (this.mode == "main"){
            if (this.loginId != owners.user_id) {
                this.chucheon_url = "http://cms.btcxclub.com/tree/huwon/" + this.api_key + "/" + owners.user
            } else {
                this.chucheon_url = "http://cms.btcxclub.com/tree/huwon/" + this.api_key
            }
		} else {
            if (this.loginId != owners.user_id) {
                this.chucheon_url = "http://btcxclub.ddsapp.net/tree/huwon/" + this.api_key + "/" + owners.user
            } else {
                this.chucheon_url = "http://btcxclub.ddsapp.net/tree/huwon/" + this.api_key
            }
		}
    }

	_close() {
		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/huwon/huwon.ts